export const paymentTermOptions = [
    {
        label: '8 dias a contar da data da Factura',
        discount: ''
    },
    {
        label: '15 dias a contar da data da Factura',
        discount: ''
    },
    {
        label: '30 dias a contar da data da Factura',
        discount: 0.005
    },
    {
        label: '45 dias a contar da data da Factura',
        discount: ''
    },
    {
        label: '60 dias a contar da data da Factura',
        discount: ''
    },
    {
        label: '75 dias a contar da data da Factura',
        discount: ''
    },
    {
        label: '90 dias a contar da data da Factura',
        discount: ''
    },
    {
        label: '120 dias a contar da data da Factura',
        discount: 0.03
    },
    {
        label: '150 dias a contar da data da Factura',
        discount: ''
    },
    {
        label: '180 dias a contar da data da Factura',
        discount: ''
    }
]

export const expirationDateOptions = [
    {
        label: 'A proposta é válida até 31 de Dezembro do corrente ano',
    },
    {
        label: 'A proposta é válida por 90 dias'
    },
    {
        label: 'A proposta é válida por 120 dias'
    },
    {
        label: 'A proposta é válida durante a vigência do contrato'
    }
]

export const dosageFormOptions = [
    {
        label: 'Ampolas'
    },
    {
        label: 'Cápsulas'
    },
    {
        label: 'Comprimidos'
    },
    {
        label: 'Pó e solvente para solução injetável'
    },
    {
        label: 'Saquetas'
    },
    {
        label: 'Solução Retal'
    },
    {
        label: 'Xarope'
    },
]

export const classificationDrugOptions = [
    {
        label: '',
    },
    {
        label: 'MSRM',
    },
]

export const supplyConditionsOptions = [
    {
        label: 'O valor mínimo de cada encomenda é de 50,00€, sem incluir I.V.A.',
    },
    {
        label: 'O valor mínimo de cada encomenda é de 50,00€, sem incluir I.V.A. (pode incluir mais do que um produto)',
    },
]

export const deadlineOptions = [
    {
        label: 'Imediato',
    },
    {
        label: 'Até 3 dias',
    },
    {
        label: 'Até 5 dias',
    },
    {
        label: 'Até 15 dias'
    },
    {
        label: 'Em data a acordar entre as partes'
    }
]